'use strict';
(function initializeBastionRecentAdapter(root) {
    const app = root.dndNextLevel;
    app.bastion = app.bastion || {};
    const TYPE = 'bastion';
    const STORAGE_KEY = 'dnd-next-level:bastion-current';
    const RESTORE_KEY = 'dnd-next-level:bastion:restore:v1';
    const clone = value => JSON.parse(JSON.stringify(value));
    const hasText = value => typeof value === 'string' && value.trim().length > 0;
    const validBastion = bastion => Boolean(
        bastion && typeof bastion === 'object' && hasText(bastion.bastionName) &&
        (!Object.hasOwn(bastion, 'characterName') || typeof bastion.characterName === 'string') &&
        (!Object.hasOwn(bastion, 'basicFacilities') || Array.isArray(bastion.basicFacilities)) &&
        (!Object.hasOwn(bastion, 'specialFacilities') || Array.isArray(bastion.specialFacilities))
    );
    const adapter = {
        type: TYPE,
        route: '/bastion',
        capture(source) {
            const bastion = source?.bastion || source;
            return validBastion(bastion) ? {version: 1, bastion: clone(bastion)} : null;
        },
        validate(payload) { return payload?.version === 1 && validBastion(payload.bastion); },
        preview(payload) {
            if (!adapter.validate(payload)) throw new Error('Invalid Bastion recent creation');
            const bastion = payload.bastion;
            return {
                title: bastion.bastionName,
                description: [
                    hasText(bastion.characterName) ? bastion.characterName : null,
                    Number.isInteger(bastion.playerLevel) ? `Level ${bastion.playerLevel}` : null
                ].filter(Boolean).join(' · ')
            };
        },
        restore(payload) {
            if (!adapter.validate(payload)) throw new Error('Invalid Bastion recent creation');
            root.sessionStorage.setItem(RESTORE_KEY, JSON.stringify(payload));
            root.location.assign(adapter.route);
            return payload.bastion;
        }
    };
    const readShared = storage => app.recentCreationStore.create(storage).read().filter(entry => entry.type === TYPE);
    const saveCurrent = (source, storage = root.localStorage, pinned = false, now = Date.now()) => {
        const payload = adapter.capture(source);
        if (!payload || !app.recentCreationStore) return null;
        const store = app.recentCreationStore.create(storage);
        const previous = store.read().find(entry => entry.type === TYPE && entry.id === 'current');
        const entry = {id: 'current', type: TYPE, createdAt: previous?.createdAt ?? now, updatedAt: now,
            pinned: pinned || previous?.pinned || false, payload};
        store.save(entry);
        app.recentCreations?.instance?.render();
        return entry;
    };
    const consumeRestore = (storage = root.localStorage, sessionStorage = root.sessionStorage) => {
        const raw = sessionStorage.getItem(RESTORE_KEY);
        sessionStorage.removeItem(RESTORE_KEY);
        if (!raw) return null;
        try {
            const payload = JSON.parse(raw);
            if (!adapter.validate(payload)) return null;
            storage.setItem(STORAGE_KEY, JSON.stringify(payload.bastion));
            return clone(payload.bastion);
        } catch (_error) { return null; }
    };
    app.bastionRecentAdapter = {adapter, saveCurrent, readShared, consumeRestore, RESTORE_KEY, STORAGE_KEY};
    app.recentCreationAdapters?.registry?.register(adapter);
})(window);
